import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';

import { LeafletCachedTileLayer } from './leafletCachedTileLayer';
import { changeMapCRSAndZoomLimits, setInitialCRSAndZoomLimits } from '../../geoUtils';
import { ITileLayerInfo } from '../../layers';
import { ITileCache } from '../../TileCache/types';


type MapCachedTileLayerProps = {
    layerInfo: ITileLayerInfo,
    tileCache: ITileCache
};


const MapCachedTileLayer = (props: MapCachedTileLayerProps) => {
     
    const map = useMap();
    const layer = useRef<LeafletCachedTileLayer>();
    
    useEffect(() => {

        const bounds = map.getBounds();

        layer.current?.removeFrom(map);

        if (!!layer.current) {
            changeMapCRSAndZoomLimits(map, props.layerInfo.crs, props.layerInfo.minZoom, props.layerInfo.maxZoom);
        }
        else {
            setInitialCRSAndZoomLimits(map, props.layerInfo.crs, props.layerInfo.minZoom, props.layerInfo.maxZoom, props.layerInfo.defaultZoom);
        }

        layer.current = 
            new LeafletCachedTileLayer(
                props.layerInfo.urlTemplate, props.layerInfo.urlSubdomains ?? [], props.tileCache, 
                {
                    // attribution: props.layerInfo.attribution
                }
            )
            .addTo(map);

        map.fitBounds(bounds);

        return () => {
            layer.current?.removeFrom(map);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [props.layerInfo]);

    return <></>;
}
 
export default MapCachedTileLayer;